export default "__VITE_ASSET__DfI9xsM$__";